import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || '/api'

const client = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
})

// Attach JWT token to every request
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Handle 401 globally
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt_token')
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

export default client

// Auth API
export const authApi = {
  login: (email, password) =>
    client.post('/auth/login', { username: email, password }),
}

// Cards API (public)
export const cardsApi = {
  getBySlug: (slug, source = 'direct') =>
    client.get(`/cards/${slug}?source=${source}`),
  downloadVcf: (slug) => `${API_URL}/cards/${slug}/vcf`,
  getQrUrl: (slug) => `${API_URL}/cards/${slug}/qr`,
}

// Admin APIs
export const adminUsersApi = {
  list: () => client.get('/admin/users'),
  get: (id) => client.get(`/admin/users/${id}`),
  create: (data) => client.post('/admin/users', data),
  update: (id, data) => client.put(`/admin/users/${id}`, data),
  delete: (id) => client.delete(`/admin/users/${id}`),
  me: () => client.get('/admin/users/me'),
}

export const adminCardsApi = {
  list: () => client.get('/admin/cards'),
  stats: (id) => client.get(`/admin/cards/${id}/stats`),
  regenerate: (id) => client.post(`/admin/cards/${id}/regenerate`),
}
